var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdulendoLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 285.743,
    height: 79,
    viewBox: "0 0 285.743 79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "l",
    x: 110.9,
    y: 4,
    width: 29,
    height: 75,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.333
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "l-2",
    x: 110.9,
    y: 0,
    width: 29,
    height: 75,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: -2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "e",
    x: 128.5,
    y: 4,
    width: 47,
    height: 75,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.333
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "e-2",
    x: 128.5,
    y: 0,
    width: 47,
    height: 75,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: -2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "n",
    x: 161.9,
    y: 4,
    width: 51,
    height: 75,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.333
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "n-2",
    x: 161.9,
    y: 0,
    width: 51,
    height: 75,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: -2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "d",
    x: 198.4,
    y: 4,
    width: 53,
    height: 75,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur-7"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.333
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "d-2",
    x: 198.4,
    y: 0,
    width: 53,
    height: 75,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: -2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur-8"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "d-3",
    x: 35,
    y: 4,
    width: 53,
    height: 75,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur-9"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.333
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "d-4",
    x: 35,
    y: 0,
    width: 53,
    height: 75,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: -2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur-10"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-10"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "e-3",
    x: 0,
    y: 4,
    width: 47,
    height: 75,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur-11"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.333
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-11"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "u",
    x: 72.5,
    y: 4,
    width: 51,
    height: 75,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur-12"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.333
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-12"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "u-2",
    x: 72.5,
    y: 0,
    width: 51,
    height: 75,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: -2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur-13"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-13"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "e-4",
    x: 0,
    y: 0,
    width: 47,
    height: 75,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: -2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur-14"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-14"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Pfad_268",
    x: 239.415,
    y: 22.637,
    width: 43.608,
    height: 43.72,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur-15"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.325
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-15"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Pfad_269",
    x: 239.397,
    y: 18.637,
    width: 43.625,
    height: 43.72,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: -2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur-16"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-16"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_19",
    x: 263.57,
    y: 30.705,
    width: 22.172,
    height: 21.688,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur-17"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.22
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-17"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_20",
    x: 263.57,
    y: 24.705,
    width: 22.172,
    height: 21.688,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: -4,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur-18"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-18"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_460",
    "data-name": "Gruppe 460",
    transform: "translate(-253.6 -165)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 253.6, 165)",
    filter: "url(#l)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "l-3",
    "data-name": "l",
    transform: "translate(116.9 58)",
    fill: "#3e3e3e",
    fontSize: 57,
    fontFamily: "Comfortaa"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "l"))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 253.6, 165)",
    filter: "url(#l-2)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "l-4",
    "data-name": "l",
    transform: "translate(116.9 58)",
    fill: "#3e3e3e",
    fontSize: 57,
    fontFamily: "Comfortaa"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "l"))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 253.6, 165)",
    filter: "url(#e)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "e-5",
    "data-name": "e",
    transform: "translate(134.5 58)",
    fill: "#3e3e3e",
    fontSize: 57,
    fontFamily: "Comfortaa"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "e"))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 253.6, 165)",
    filter: "url(#e-2)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "e-6",
    "data-name": "e",
    transform: "translate(134.5 58)",
    fill: "#3e3e3e",
    fontSize: 57,
    fontFamily: "Comfortaa"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "e"))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 253.6, 165)",
    filter: "url(#n)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "n-3",
    "data-name": "n",
    transform: "translate(167.9 58)",
    fill: "#3e3e3e",
    fontSize: 57,
    fontFamily: "Comfortaa"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "n"))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 253.6, 165)",
    filter: "url(#n-2)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "n-4",
    "data-name": "n",
    transform: "translate(167.9 58)",
    fill: "#3e3e3e",
    fontSize: 57,
    fontFamily: "Comfortaa"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "n"))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 253.6, 165)",
    filter: "url(#d)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "d-5",
    "data-name": "d",
    transform: "translate(204.4 58)",
    fill: "#3e3e3e",
    fontSize: 57,
    fontFamily: "Comfortaa"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "d"))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 253.6, 165)",
    filter: "url(#d-2)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "d-6",
    "data-name": "d",
    transform: "translate(204.4 58)",
    fill: "#3e3e3e",
    fontSize: 57,
    fontFamily: "Comfortaa"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "d"))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 253.6, 165)",
    filter: "url(#d-3)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "d-7",
    "data-name": "d",
    transform: "translate(41 58)",
    fill: "#4591b2",
    fontSize: 57,
    fontFamily: "Comfortaa"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "d"))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 253.6, 165)",
    filter: "url(#d-4)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "d-8",
    "data-name": "d",
    transform: "translate(41 58)",
    fill: "#4591b2",
    fontSize: 57,
    fontFamily: "Comfortaa"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "d"))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 253.6, 165)",
    filter: "url(#e-3)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "e-7",
    "data-name": "e",
    transform: "translate(6 58)",
    fill: "#4591b2",
    fontSize: 57,
    fontFamily: "Comfortaa"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "e"))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 253.6, 165)",
    filter: "url(#u)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "u-3",
    "data-name": "u",
    transform: "translate(78.5 58)",
    fill: "#4591b2",
    fontSize: 57,
    fontFamily: "Comfortaa"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "u"))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 253.6, 165)",
    filter: "url(#u-2)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "u-4",
    "data-name": "u",
    transform: "translate(78.5 58)",
    fill: "#4591b2",
    fontSize: 57,
    fontFamily: "Comfortaa"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "u"))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 253.6, 165)",
    filter: "url(#e-4)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "e-8",
    "data-name": "e",
    transform: "translate(6 58)",
    fill: "#4591b2",
    fontSize: 57,
    fontFamily: "Comfortaa"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "e"))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_459",
    "data-name": "Gruppe 459",
    transform: "translate(501 193.643)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -247.4, -28.64)",
    filter: "url(#Pfad_268)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_268-2",
    "data-name": "Pfad 268",
    d: "M7356.979-2703.25a14.977,14.977,0,0,0-6.369-1.8,13.563,13.563,0,0,0-14.021,14.4c.5,9.372,7.825,13.221,13.7,13.294s13.581-4.843,13.826-13.294",
    transform: "translate(-7089.15 2733.72)",
    fill: "none",
    stroke: "#3e3e3e",
    strokeLinecap: "round",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -247.4, -28.64)",
    filter: "url(#Pfad_269)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_269-2",
    "data-name": "Pfad 269",
    d: "M7356.974-2703.25a14.977,14.977,0,0,0-6.369-1.8,13.576,13.576,0,0,0-14.038,14.4c.5,9.372,7.843,13.221,13.717,13.294s13.581-4.843,13.826-13.294",
    transform: "translate(-7089.14 2733.72)",
    fill: "none",
    stroke: "#3e3e3e",
    strokeLinecap: "round",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_448",
    "data-name": "Gruppe 448",
    transform: "translate(22.17 6.062)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    cx: 5.086,
    cy: 4.844,
    rx: 5.086,
    ry: 4.844,
    transform: "translate(0 0)",
    fill: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -269.57, -34.71)",
    filter: "url(#Ellipse_19)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_19-2",
    "data-name": "Ellipse 19",
    cx: 5.086,
    cy: 4.844,
    rx: 5.086,
    ry: 4.844,
    transform: "translate(269.57 34.71)",
    fill: "#3e3e3e"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -269.57, -34.71)",
    filter: "url(#Ellipse_20)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_20-2",
    "data-name": "Ellipse 20",
    cx: 5.086,
    cy: 4.844,
    rx: 5.086,
    ry: 4.844,
    transform: "translate(269.57 34.71)",
    fill: "#4591b2"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdulendoLogo);
export default __webpack_public_path__ + "static/media/edulendo_logo.1daf89f457c1ea00ea6a9c7d99e680b6.svg";
export { ForwardRef as ReactComponent };